export function getYMClientId() {
  const cookieValue = document.cookie.match('(^|;)\\s*_ym_uid=([^;]+)')?.pop() || '';
  if (cookieValue) {
    return cookieValue;
  }
  return '';
}
